module.exports = __webpack_public_path__ + "img/Prepare_the_Area.b15771b6.png";